import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { SpinnerService } from "app/shared/services/spinner/spinner.service";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"]
})
export class SpinnerComponent implements OnInit, OnDestroy {
  @Input()
  showSpinner: boolean = false;
  show = false;
  private subscription: Subscription;
  constructor(private spinnerService: SpinnerService) {}
  ngOnInit() {
    this.subscription = this.spinnerService.loaderState.subscribe(
      (state: any) => {
        this.showSpinner = state;
      }
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner/spinner.component.ts